/* ==========================================================================
   TrautMeyer · Kategorieseiten
   assets/traut-collection.js
   Version 1.0

   TUT GENAU EINE SACHE
     Bereitet Tabellen im Kategorietext fuer kleine Bildschirme vor, indem
     jede Zelle die Bezeichnung ihrer Spalte als Attribut mitbekommt. Die
     Darstellung uebernimmt das Stylesheet.

   SICHERHEIT
     Gibt es keinen Kategorietext auf der Seite, passiert nichts. Es wird
     ausschliesslich ein Attribut gesetzt und hoechstens eine vorhandene
     Zeile verschoben; kein innerHTML wird neu geschrieben. Ohne JavaScript
     bleibt die Tabelle eine vollstaendige, lesbare Tabelle und wird auf
     schmalen Schirmen seitlich schiebbar.

   KEINE HALBEN SACHEN
     Sobald Zellen zusammengefasst sind oder eine Zeile anders viele Zellen
     hat als der Kopf, stimmt die Zuordnung Spalte zu Zelle nicht mehr.
     Dann wird NICHTS markiert und es bleibt beim Schieben. Eine falsche
     Beschriftung waere schlimmer als gar keine.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = '.traut-collection-text [data-traut-collection-text]';

  /* Eine Kopfzeile ohne thead zu einer echten Kopfzeile machen.

     Kommt die Tabelle als <table><tr><th>… an, steckt der Browser ALLE
     Zeilen in einen stillschweigend ergaenzten tbody und table.tHead bleibt
     leer, obwohl die erste Zeile offensichtlich der Kopf ist. Erkannt wird
     das daran, dass diese Zeile ausschliesslich aus th-Zellen besteht —
     eine Tabelle mit Zeilenkoepfen links bleibt damit unberuehrt. */
  function normalizeHead(table) {
    if (table.tHead) return;

    var bodies = table.tBodies;
    if (!bodies.length || !bodies[0].rows.length) return;

    var first = bodies[0].rows[0];
    if (!first.cells.length) return;
    for (var i = 0; i < first.cells.length; i++) {
      if (first.cells[i].tagName.toLowerCase() !== 'th') return;
    }

    var head = document.createElement('thead');
    table.insertBefore(head, bodies[0]);
    head.appendChild(first);
  }

  function labelCells(table) {
    var head = table.tHead;
    if (!head || !head.rows.length) return;

    /* Bei mehrzeiligem Kopf zaehlt die unterste Zeile: dort stehen die
       Spalten, zu denen die Zellen darunter gehoeren. */
    var headRow = head.rows[head.rows.length - 1];
    var labels = [];
    for (var i = 0; i < headRow.cells.length; i++) {
      var cell = headRow.cells[i];
      if (cell.colSpan > 1 || cell.rowSpan > 1) return;
      labels.push(String(cell.textContent || '').replace(/\s+/g, ' ').trim());
    }
    if (!labels.length) return;

    var rows = [];
    for (var b = 0; b < table.tBodies.length; b++) {
      var body = table.tBodies[b];
      for (var r = 0; r < body.rows.length; r++) {
        var row = body.rows[r];
        if (row.cells.length !== labels.length) return;
        for (var c = 0; c < row.cells.length; c++) {
          if (row.cells[c].colSpan > 1 || row.cells[c].rowSpan > 1) return;
        }
        rows.push(row);
      }
    }
    if (!rows.length) return;

    for (var k = 0; k < rows.length; k++) {
      var cells = rows[k].cells;
      for (var m = 0; m < cells.length; m++) {
        if (labels[m]) cells[m].setAttribute('data-traut-label', labels[m]);
      }
    }

    table.setAttribute('data-traut-stack', '');
  }

  function init() {
    var containers = document.querySelectorAll(ROOT);
    if (!containers.length) return;

    for (var i = 0; i < containers.length; i++) {
      if (containers[i].getAttribute('data-traut-tables-done') === '1') continue;
      containers[i].setAttribute('data-traut-tables-done', '1');

      var tables = containers[i].querySelectorAll('table');
      for (var t = 0; t < tables.length; t++) {
        normalizeHead(tables[t]);
        labelCells(tables[t]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
